import { Controller } from "@hotwired/stimulus"

/**
 * Job Error / Handler Modal Controller
 *
 * Shows the full "last error" trace or full handler YAML for an admin job
 * in a modal when the corresponding cell or link is clicked.
 */
export default class extends Controller {
  static values = {}

  show(event) {
    const trigger = event.currentTarget
    const fullError = trigger.dataset.jobErrorModalFullErrorValue
    const body = document.getElementById("job-error-modal-body")
    const modalEl = document.getElementById("job-error-modal")
    if (!body || !modalEl) return
    body.textContent = fullError || ""
    const modal = window.bootstrap?.Modal?.getOrCreateInstance(modalEl)
    if (modal) modal.show()
  }

  showHandler(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const fullHandler = trigger.dataset.jobErrorModalFullHandlerValue
    const body = document.getElementById("job-handler-modal-body")
    const modalEl = document.getElementById("job-handler-modal")
    if (!body || !modalEl) return
    body.textContent = fullHandler || ""
    const modal = window.bootstrap?.Modal?.getOrCreateInstance(modalEl)
    if (modal) modal.show()
  }
}
